import React from "react";

function  Header() {
  return (
    <>
      <div className="header-section">
        {/*  Header Top Start */}
        <div className="header-top d-none d-lg-block">
          <div className="container">
            {/*  Header Top Wrapper Start */}
            <div className="header-top-wrapper">
              {/*  Header Top Left Start */}
              <div className="header-top-left">
                <p>
                  All course 30% off for <a href="https://app.techijack.com/">New users.</a>
                </p>
              </div>
              {/*  Header Top Left End */}

              {/*  Header Top Medal Start */}
              <div className="header-top-medal">
                <div className="top-info">
                  {/*    <p><i className="flaticon-phone-call"></i> <a href="tel:9702621413">(970) 262-1413</a></p> */}
                  <p>
                    <i className="flaticon-email"></i>{" "}
                    <a href="mailto:info@techijack.com">info@techijack.com</a>
                  </p>
                </div>
              </div>
              {/*  Header Top Medal End */}

              {/*  Header Top Right Start */}
              <div className="header-top-right">
                <ul className="social">
                  <li>
                    <a
                      href="https://www.facebook.com/ServerTraining"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="flaticon-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com/jack_techi"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="flaticon-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="skype:vicky00284?chat"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="flaticon-skype"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/c/techijack?sub_confirmation=1"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="flaticon-tutor"></i>
                    </a>
                  </li>
                </ul>
              </div>
              {/*  Header Top Right End */}
            </div>
            {/*  Header Top Wrapper End */}
          </div>
        </div>
        {/*  Header Top End */}

        <div className="header-main">
          <div className="container">
            {/*  Header Main Start **/}
            <div className="header-main-wrapper">
              {/*  Header Logo Start **/}
              <div className="header-logo">
                <a href="/">
                  <img src="assets/images/logo.png" alt="Logo" />
                </a>
              </div>
              {/*  Header Logo End **/}

              {/*  Header Menu Start **/}
              <div className="header-menu d-none d-lg-block">
                <ul className="nav-menu">
                  <li>
                    <a href="/#courses">Courses</a>
                  </li>
                  <li>
                    <a href="/#mobileapp">Mobile App</a>
                  </li>
                  <li>
                    <a
                      href="https://techijack.com/blog/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Blog
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://techijack.com/contact-us/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Contact
                    </a>
                  </li>
                </ul>
              </div>
              {/*  Header Menu End **/}

              {/*  Header Sing In & Up Start **/}
              <div className="header-sign-in-up d-none d-lg-block">
                <ul>
                  <li>
                    <a className="sign-up" href="https://app.techijack.com/">
                      Get Started
                    </a>
                  </li>
                </ul>
              </div>
              {/*  Header Sing In & Up End **/}

              {/*  Header Mobile Toggle Start **/}
              <div className="header-toggle d-lg-none">
                <a className="menu-toggle" href="/#">
                  <span></span>
                  <span></span>
                  <span></span>
                </a>
              </div>
              {/*  Header Mobile Toggle End **/}
            </div>
            {/*  Header Main End **/}
          </div>
        </div>
      </div>

      {/*  Mobile Menu Start **/}
      <div className="mobile-menu">
        {/*  Menu Close Start **/}
        <a className="menu-close" href="/#">
          <i className="icofont-close-line"></i>
        </a>
        {/*  Menu Close End **/}

        {/*  Mobile Top Medal Start **/}
        <div className="mobile-top">
          <p>
            <i className="flaticon-email"></i>{" "}
            <a href="mailto:info@techijack.com">info@techijack.com</a>
          </p>
        </div>
        {/*  Mobile Top Medal End **/}

        {/*  Mobile Sing In & Up Start **/}
        <div className="mobile-sign-in-up">
          <ul>
            <li>
              <a className="sign-in" href="app.techijack.com">
                Sign In
              </a>
            </li>
          </ul>
        </div>
        {/*  Mobile Sing In & Up End **/}

        {/*  Mobile Menu Start **/}
        <div className="mobile-menu-items">
          <ul className="nav-menu">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/#courses">All Course</a>
            </li>
            <li>
              <a href="/#mobileapp">Download App</a>
            </li>
          </ul>
        </div>
        {/*  Mobile Menu End **/}

        {/*  Mobile Menu End **/}
        <div className="mobile-social">
          <ul className="social">
            <li>
              <a
                href="https://www.facebook.com/ServerTraining"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="flaticon-facebook"></i>
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/jack_techi"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="flaticon-twitter"></i>
              </a>
            </li>
            <li>
              <a
                href="skype:vicky00284?chat"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="flaticon-skype"></i>
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/c/techijack?sub_confirmation=1"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="flaticon-youtube"></i>
              </a>
            </li>
          </ul>
        </div>
        {/*  Mobile Menu End **/}
      </div>
      {/*  Mobile Menu End **/}
    </>
  );
}

export default Header;
